import React, { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import Button from "./Button";

const UpdateVersion = ({ setShowUpdateVersion }) => {
  return (
    <Transition.Root show={true} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={setShowUpdateVersion}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <div
                className="inline-block w-full relative bg-white rounded-md shadow-xl transform transition-all  "
                style={{ maxWidth: "460px", zIndex: "9999999" }}
              >
                <div className="flex flex-col text-center mb-6 px-4  sm:py-6 sm:px-10 w-full">
                  <h1 className="text-[#333] font-semibold text-xl py-4 px-6 sm:px-0">
                    New version is available.
                  </h1>

                  <div className="flex items-center space-x-6 mx-auto mt-2">
                    <Button
                      type="button"
                      additionalClasses="w-40  bg-primary text-white h-10 rounded-md"
                      title="Update Now"
                      onClick={() => {
                        setShowUpdateVersion(false);
                        window.location.reload(true);
                      }}
                    />
                  </div>
                </div>
              </div>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default UpdateVersion;
